module.exports = __webpack_public_path__ + "static/img/d5-1sk.2fcd87b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/english/home/pc/role/d5-1sk.png
// module id = gqml
// module chunks = 0